// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as Turbo from "@hotwired/turbo"
import "./controllers"

window.Turbo = Turbo


// We should not import the css file here, as it will overwrite
// the css file that is already imported in the application.css file
// import 'jodit/es2021/jodit.min.css'; // standart css
import { Jodit } from 'jodit/esm/index.js';
import { file } from "jodit/esm/plugins/file/file";



// Variable to hold the editor instance
let editorInstance = null;

document.addEventListener("turbo:load", function() {
  try {
    // Check if an editor instance already exists
    if (editorInstance !== null) {
      // Destroy the existing editor instance
      editorInstance.destruct();
      editorInstance = null; // Reset the instance variable
    }

    // Check if the editor element exists on the page
    const editorElement = document.querySelector('#editor');
    if (editorElement) {
      // Initialize a new Jodit editor instance and store it in the variable
      editorInstance = new Jodit(editorElement, {
        uploader: {
          url: '/meetings/uploadimage',
          format: 'json',
          isSuccess: function(resp) {
            console.log('isSuccess', resp.success); 
            return resp.success === 1;
          },
          process: function (resp) {
            console.log('isSuccess', resp); 
            console.log('isSuccess', resp.data.url); 
            return {
              files:    resp.data.files,
              path:     resp.data.path,
              baseurl:  resp.data.baseurl,
              message:  resp.data.message
            };
          },  
          defaultHandlerSuccess: function (data) {
            var i, field = 'files', imageUrl, file_extension;                      
            if (data[field] && data[field].length) {
              for (i = 0; i < data[field].length; i += 1) {

                imageUrl = data.baseurl + data[field][i]
                file_extension = imageUrl.split('.').pop();

                if (this.jodit) {

                  // Drag & drop case
                  const editor = this.jodit;  // 'this.jodit' is our Jodit instance
                  const selection = editor.s; // Get the selection from the editor instance
                  if (selection) {
                    if (file_extension == 'pdf') {
                      selection.insertHTML('<a href="' + imageUrl + '" target="_blank">' + imageUrl + '</a>');
                    } else {
                      selection.insertImage(imageUrl);
                    }
                  } else {
                    console.error('Selection not found');
                  }

                } else {

                  // Works with button
                  if (file_extension == 'pdf') {
                    this.selection.insertHTML('<a href="' + imageUrl + '" target="_blank">' + imageUrl + '</a>');
                  } else {
                    this.selection.insertImage(data.baseurl + data[field][i]);
                  }
                }
                
                // Alt 1
                // const image = editor.selection.insertImage(data.baseurl + data[field][i]);
                // // Ensure the cursor is set after the image
                // if (image) {
                //   editor.selection.setCursorAfter(image);
                // }


              }
            }
          },
          error: function(e) {
            console.error(e);
          }
        },
        
        buttons: ['bold','italic','underline','strikethrough','|',
                  'ul','ol','|','outdent','indent','|',
                  // 'left','center','right','justify','|',
                  'font','fontsize','brush','paragraph','|',
                  // 'align',
                  'undo','redo','|',
                  // 'hr',
                  'table','link','|',
                  { name: 'image' , tooltip: 'Insert image or pdf'}, 
                  // 'video', 'file', '|',
                  // 'source','fullsize', '|', 
                  'print'],
        width: '100%'
      });
      console.log('Jodit initialized successfully');
    } else {
      console.warn('Editor element not found');
    }
  } catch (error) {
    console.error('Error initializing Jodit:', error);
  }
});




// buttons: [
//   "aligncenter",
//   "alignfull",
//   "alignleft",
//   "alignright",
//   "application",
//   "bgcolorpicker",
//   "charmap",
//   "colorpicker",
//   "directionltr",
//   "directionrtl",
//   "find",
//   "fontfamily",
//   "fontsize",
//   "fullscreen",
//   "image",
//   "indent",
//   "language",
//   "link",
//   "outdent",
//   "preview",
//   "print",
//   "redo",
//   "replace",
//   "selectall",
//   "showabout",
//   "showadvanced",
//   "showadvancedtab",
//   "showblockinspector",
//   "showcharmap",
//   "showcss",
//   "showcustomformat",
//   "showemoji",
//   "showemotion",
//   "showfontbackground",
//   "showfontbackgroundcolorpicker",
//   "showfontborder",
//   "showfontbordercolorpicker",
//   "showfontcolor",
//   "showfontcolorpicker",
//   "showfontface",
//   "showfontfamily",
//   "showfonteffect",
//   "showfontname",
//   "showfontstyle",
//   "showfontsize",
//   "showfontsizeselect",
//   "showfontweight",
//   "showhelp",
//   "showhtml",
//   "showlist",
//   "showphp",
//   "showquickinsert",
//   "showstatus",
//   "showstylesheets",
//   "showtoolbar",
//   "showwordcount",
//   "smiley",
//   "source",
//   "specialchars",
//   "templates",
//   "undo",
//   "unlink",
//   "video"],


// Additional options
// height: 300,
// readonly: false,
// showAbout: true,
// showAdvanced: true,
// showAdvancedTab: true,
// showAlignAbsMiddle: true,
// showAlignAbsoluteMiddle: true,
// showAlignBaseline: true,
// showAlignBottom: true,
// showAlignMiddle: true,
// showAlignTextCenter: true,
// showAlignTextLeft: true,
// showAlignTextRight: true,
// showBackgroundColorPicker: true,
// showBlockinspector: true,
// showBold: true,
// showCharMap: true,
// showCharsCounter: true,
// showColorPicker: true,
// showCSS: false,
// showCustomFormat: true,
// showDirectionRTL: true,
// showEmoticons: true,
// showEmoji: false,
// showFind: true,
// showFontFamily: true,
// showFontSize: true,
// showFullScreen: true,
// showHelp: true,
// showHtml: false,
// showImage: true,
// showIndent: true,
// showItalic: true,
// showJustifyCenter: true,
// showJustifyFull: true,
// showJustifyLeft: true,
// showJustifyRight: true,
// showLanguageSelector: true,
// showLanguageSelectorOnBlur: true,
// showLanguageSelectorOnChange: true,
// showLanguageSelectorOnClick: true,
// showLanguageSelectorOnCompositionEnd: true,
// showLanguageSelectorOnCompositionEndAsNew: true,
// showLanguageSelectorOnCompositionStart: true,
// showLanguageSelectorOnCompositionStartAsNew: true,
// showLanguageSelectorOnCut: true,
// showLanguageSelectorOnCutAsNew: true,
// showLanguageSelectorOnDragOver: true,
// showLanguageSelectorOnDragOverAsNew: true,
// showLanguageSelectorOnDrop: true,
// showLanguageSelectorOnDropAsNew: true,
// showLanguageSelectorOnFocus: true,
// showLanguageSelectorOnInput: true,
// showLanguageSelectorOnInputAsNew: true,
// showLanguageSelectorOnKeyDown: true,
// showLanguageSelectorOnKeyDownAsNew: true,
// showLanguageSelectorOnKeyPress: true,
// showLanguageSelectorOnKeyPressAsNew: true,
// showLanguageSelectorOnKeyUp: true,
// showLanguageSelectorOnKeyUpAsNew: true,
// showLanguageSelectorOnPaste: true,
// showLanguageSelectorOnPasteAsNew: true,
// showLanguageSelectorOnSelectionChange: true,
// showLanguageSelectorOnSelectionChangeAsNew: true,
// showLessToolbar: true,
// showLineHeight: true,
// showList: true,
// showMedia: false,
// showMoreToolbar: true,
// showNonBreakingSpace: true,
// showOutdent: true,
// showPageBreak: true,
// showPHP: false,
// showPlugins: ['print', 'fullscreen', 'smiley', 'blockinspector', 'image'],
// showPreview: true,
// showPrint: true,
// showQuickInsert: false,
// showRedo: true,
// showRemoveFormat: true,
// showReplace: true,
// showSave: false,
// showSelectAll: true,
// showSmiley: true,
// showSourceButton: true,
// showSpecialCharacters: true,
// showSplitBlock: true,
// showStatus: true,
// showStrikeThrough: true,
// showStylesheet: true,
// showSubscript: true,
// showSuperscript: true,
// showTemplates: true,
// showTemplatesPredefined: true,
// showToolbar: true,
// showUnderline: true,
// showUndo: true,
// showWordCount: true,
// showXPath: false,